import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import { captureFirstTouchUtm } from './utils/firstTouchUtm';

import * as serviceWorker from './serviceWorker';

// Must run before render: the root route redirects on mount and wipes the query string.
captureFirstTouchUtm();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
